var _path, _path2, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteNodata(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 92,
    viewBox: "0 0 79 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88672 2.51416H40.9081L53.181 11.314L63.8804 25.1423L65.4538 78.5698H1.88672V2.51416Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3016 22.8276V80.6575H0V0H45.3557L67.3016 22.8276ZM5.85247 74.5701H61.4491V28.6903H39.3459V6.08732H5.85247V74.5701ZM32.7276 69.1415H11.9582V62.8559H32.7276V69.1415ZM54.7558 37.7418V54.0278L33.2126 59.8033L11.9582 54.0205V37.7491L33.2126 31.9663L54.7558 37.7418ZM35.5992 47.4212V53.956L49.7208 50.1711V43.0182L35.5992 47.4212ZM16.9932 50.1785L30.5641 53.8707V47.2487L16.9932 43.0176V50.1785ZM23.5709 39.8005L33.3576 42.8519L43.0847 39.819L33.2218 37.1752L23.5709 39.8005ZM45.0411 22.7349H58.9371L45.0411 8.28053V22.7349Z",
    fill: "#9D9EB7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.9844,
    cy: 75.2329,
    r: 16,
    fill: "#F00000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7782 67.222C71.6373 68.0812 71.6373 69.4741 70.7782 70.3333L66.1113 75.0002L70.7782 79.6671C71.6373 80.5263 71.6373 81.9192 70.7782 82.7784C69.919 83.6375 68.5261 83.6375 67.6669 82.7784L63 78.1115L58.3331 82.7784C57.4739 83.6375 56.081 83.6375 55.2218 82.7784C54.3627 81.9192 54.3627 80.5263 55.2218 79.6671L59.8887 75.0002L55.2218 70.3333C54.3627 69.4741 54.3627 68.0812 55.2218 67.222C56.081 66.3629 57.4739 66.3629 58.3331 67.222L63 71.8889L67.6669 67.222C68.5261 66.3629 69.919 66.3629 70.7782 67.222Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteNodata);
export default __webpack_public_path__ + "static/media/quoteNodata.082883e5aeb88bbb38327337be9901d5.svg";
export { ForwardRef as ReactComponent };